import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavController, NavParams, ModalController, ToastController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { from } from 'rxjs';
import { LoadingSpinnerComponent } from 'src/app/components/loading/loading-spinner/loading-spinner.component';

import { ImagePipe } from 'src/app/pipes/image/image';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { NomenclaturaService } from 'src/app/services/nomenclatura/nomenclatura';
import { OracaoProvider } from 'src/app/services/oracao/oracao';
import { UserProvider } from 'src/app/services/user/user';


@Component({
  selector: 'app-oracao-add',
  templateUrl: './oracao-add.page.html',
  styleUrls: ['./oracao-add.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    ReactiveFormsModule,
    NomenclaturaPipe,
    LoadingSpinnerComponent
  ],
})
export class OracaoAddPage implements OnInit {
  isTestemunho: boolean = false;
  idOracao: any;
  pessoa: any = {};
  publico: boolean = false;
  validations_form: FormGroup;
  nomenclaturaDesc: string = "";
  nomenclaturaTestemunho: string = "";
  loaded = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public oracaoProvider: OracaoProvider,
    public userProvider: UserProvider,
    public modalCtrl: ModalController,
    private nomenclatura: NomenclaturaService,
    public toastCtrl: ToastController,
    private translate: TranslateService
  ) {
    this.isTestemunho = this.navParams.get('isTestemunho');
    this.idOracao = this.navParams.get('idOracao');
    this.validations_form = this.formBuilder.group({
      pedido: new FormControl('', Validators.required),
      publico: new FormControl(false)
    });

    from(this.userProvider.getDados()).subscribe((data) => {
      this.pessoa = data;
    });
    this.nomenclatura.transform('oracao').then(data => this.nomenclaturaDesc = data);
    this.nomenclatura.transform('testemunho').then(data => this.nomenclaturaTestemunho = data);
    setTimeout(() => {
      this.loaded = true;
    },1000);
  }

  // C:\Program Files\Android\Android Studio\jre

  // C:\Program Files\Java\jre1.8.0_351\lib\amd64
  ngOnInit() {
  }

  onSubmit(oracao: { pedido: any; publico: boolean | undefined; }) {
    this.oracaoProvider.criarOracao(oracao.pedido, oracao.publico, this.idOracao, (this.isTestemunho ? '1' : '0')).subscribe(async data => {
      let message = this.nomenclaturaDesc + this.translate.instant(' cadastrada com sucesso!');
      if (this.isTestemunho) {
        message = this.nomenclaturaTestemunho + this.translate.instant(' cadastrada com sucesso!');
      }
      const toast = await this.toastCtrl.create({
        message: message,
        duration: 3000
      });

      toast.present();

      this.modalCtrl.dismiss(data);
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  validation_messages = {
    'pedido': [
      { type: 'required', message: this.translate.instant('Campo Obrigatório') }
    ]
  };
}
